import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';

import { Observable } from 'rxjs';

/** Inject With Credentials into the request */
@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  private dontInterpect = [
    'api.ipify.org'
  ];

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {

      if (!this.urlIsNotInterceptable(req.url)) {
        req = req.clone({
          withCredentials: true
        });
      }

      return next.handle(req);
  }

  private urlIsNotInterceptable(url): boolean {
    const urlsIgnored = this.dontInterpect.join('|');
    return !!url.match(urlsIgnored);
  }
}
